<template>
    <div class="address">
        <div class="center-box">
            <div class="title">{{$t('Receipt.information')}}</div>
            <div class="form-box">
                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.name')}}</span>
                    <div  class="inp">
                        <input type="text" name="" id="" class="inputs">
                    </div>
                </div>

                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.consignee')}}</span>
                    <div  class="inp">
                        <input type="text" name="" id="" class="inputs">
                    </div>
                </div>

                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.country')}}</span>
                    <div  class="inp more-inp">
                        <input type="text" name="" id="" class="mini-inputs">
                        -
                        <input type="text" name="" id="" class="mini-inputs">
                    </div>
                </div>

                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.address')}}</span>
                    <div  class="inp">
                        <input type="text" name="" id="" class="inputs">
                    </div>
                </div>
                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.Zipcode')}}</span>
                    <div  class="inp">
                        <input type="text" name="" id="" class="inputs">
                    </div>
                </div>
                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="short-title">{{$t('Receipt.tel')}}</span>
                    <div  class="inp">
                        <input type="number" name="" id="" class="inputs">
                    </div>
                </div>

                <div class="form-box-line">
                    <span class="star">*</span>
                    <span class="long-title">{{$t('Receipt.occupation')}}</span>
                    <div  class=" sm-inp">
                        <el-select v-model="value" :placeholder="$t('Receipt.choice')" popper-class = "optionsContent">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="">

                    </div>

                </div>




            </div>
        </div>
    </div>
</template>

<script>
export default {
     data() {
      return {
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: ''
      }
    }
}
</script>
<style scoped>
.address{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    padding-top: 162px;

}
.center-box{
    width: 692px;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fff;
    font-size: 13px;
}
.title{
    font-size: 14px;
    color: #1A1A1A;
    height: 32px;
    background: #F3F3F3;
    text-align: left;
    line-height: 32px;
    padding-left: 15px;
}
.form-box{
    background: #fff;
    padding: 28px;
}
.short-title{
    width: 83px;
    text-align: left;
}
.form-box-line{
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}
.star{
    color: #EE3220;
    font-size: 13px;
    margin-right: 8px;
}
.inp{
    height: 28px;
    width: 233px;


}
.inputs{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    padding-left: 10px;
    box-sizing: border-box;
    border: 1px solid #E2E2E2;
}
.mini-inputs{
    margin: 0;
    padding: 0;
    padding-left: 10px;
    box-sizing: border-box;
    width: 90px;
    border: 1px solid #E2E2E2;
    height: 100%;
}
.more-inp{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.long-title{
    width: 167px;
    text-align: left;
}
.sm-inp{
    width: 148px;
    border: 1px solid #dcdfe6;
}



</style>



// WEBPACK FOOTER //
// src/components/assembly/AddAddress.vue